import { useSelector } from 'react-redux'

// Hooks
import { useProfile } from 'modules/profile/hooks'

// Types
import { Song, Track, Genre, EntityState, Collection, Label, Region, Artist, State, CmsPage } from 'types'

export const useTracks = (): EntityState<Track> => {
  return useSelector<State, EntityState<Track>>((state: State) => state.entities.tracks)
}

export const useGenres = (): EntityState<Genre> => {
  return useSelector<State, EntityState<Genre>>((state: State) => state.entities.genres)
}

export const useSongs = (): EntityState<Song> => {
  return useSelector<State, EntityState<Song>>((state: State) => state.entities.songs)
}

export const useCollections = (): EntityState<Collection> => {
  return useSelector<State, EntityState<Collection>>((state: State) => state.entities.collections)
}

export const useLabels = (): EntityState<Label> => {
  return useSelector<State, EntityState<Label>>((state: State) => state.entities.labels)
}

export const useRegions = (): EntityState<Region> => {
  return useSelector<State, EntityState<Region>>((state: State) => state.entities.regions)
}

export const useArtists = (): EntityState<Artist> => {
  return useSelector<State, EntityState<Artist>>((state: State) => state.entities.artists)
}

export const usePages = (): EntityState<CmsPage> => {
  return useSelector<State, EntityState<CmsPage>>((state: State) => state.entities.pages)
}

export const useSongFromTrackId = (trackId: number): Song | null | undefined => {
  const tracks = useTracks()
  const songs = useSongs()
  const track = tracks[String(trackId)]
  return track ? songs[String(track.song)] : null
}

export const useTrackFromTrackId = (trackId: number): Track | undefined => {
  const tracks = useTracks()
  return tracks[String(trackId)]
}

export const useTrackIsUnpublished = (trackId: number): boolean => {
  const profile = useProfile()
  const isOwned = !!profile.purchased_tracks.find(x => +x.track === +trackId)
  return useSongFromTrackId(trackId)?.state !== 2 && !isOwned
}
